import { Controller } from '@hotwired/stimulus'

const Loader = `<div class="loading--logo"><svg
viewBox="0 0 38 28"
fill="none"
xmlns="http://www.w3.org/2000/svg"
className="loading--logo"
>
<path
  fillRule="evenodd"
  clipRule="evenodd"
  d="M30.8301 1.3652C28.1345 0.590996 25.2281 1.13687 23.005 2.83491C20.6481 4.65101 18.8477 7.20489 17.3593 9.48872C16.4559 10.9074 15.4167 12.2364 14.2562 13.4575C13.8046 13.9462 13.3054 14.3893 12.7658 14.7804C10.9043 16.0094 8.11104 15.9547 6.12517 14.6865C3.86641 13.2209 2.83173 10.4692 3.57161 7.89544C4.3115 5.32165 6.65396 3.52412 9.3527 3.45919C10.814 3.43601 12.2385 3.91368 13.3856 4.81148C13.9778 5.27333 14.4733 5.91914 14.9648 6.59627L15.0576 6.71956L15.3379 7.08943L16.8895 4.93673C16.3333 4.15788 15.6873 3.44595 14.9648 2.81534C13.3587 1.53193 11.3503 0.845855 9.28756 0.87595C5.50622 1.04507 2.24104 3.55414 1.13287 7.14227C0.0917169 10.7866 1.54768 14.68 4.73349 16.7707C7.55634 18.6162 11.4669 18.6475 14.1654 16.8627C14.316 16.7678 14.4616 16.6652 14.6016 16.5555V20.8315C14.6016 20.8628 14.6016 22.8316 13.2968 24.1858C12.4598 25.0469 11.2188 25.4774 9.57379 25.4774C6.31468 25.4774 4.73349 23.8472 4.08206 22.8629L2.37453 24.769C3.49183 26.1839 5.69484 28 9.60537 28C11.9327 28 13.7942 27.3229 15.1326 25.9393C17.1481 23.9079 17.1481 21.1094 17.1481 20.8002V14.0035C17.8943 13.1111 18.6385 12.0954 19.4755 10.8723C20.9343 8.6883 22.5175 6.41231 24.5645 4.84279C26.0865 3.64315 28.2263 3.27719 30.1194 3.79775C32.6964 4.53926 34.4915 6.85081 34.5556 9.51023C34.6197 12.1696 32.938 14.5636 30.3997 15.4263C29.0363 15.8881 27.5518 15.8549 26.2108 15.3323C25.1547 14.9409 24.223 14.1953 23.3544 13.119C23.2301 12.9644 23.0129 12.6884 22.8274 12.4105C22.6734 12.1952 22.5175 11.98 22.3931 11.8234L20.8415 13.9761C21.0586 14.2521 21.2363 14.53 21.4002 14.6826C22.549 16.1288 23.8519 17.1132 25.3482 17.6983C26.35 18.0759 27.4113 18.2747 28.4829 18.2854C29.4334 18.2876 30.3775 18.1322 31.2762 17.8255C34.8618 16.5962 37.2413 13.218 37.1706 9.4574C37.0028 5.69962 34.4612 2.45591 30.8301 1.3652Z"
  fill="#039DE7"
/>
</svg></div>`
export default class extends Controller {
  static targets = [
    'templateList',
    'activeFilters',
    'search',
    'autocompleteOptions',
    'order',
  ]

  initialize() {}

  updateResults(html) {
    const results = html.querySelector('[id="template-list"]')
    const filters = html.querySelector('[id="selected_filters"]')
    this.templateListTarget.parentElement.replaceChild(
      results,
      this.templateListTarget
    )

    this.activeFiltersTarget.parentElement.replaceChild(
      filters,
      this.activeFiltersTarget
    )
  }

  setLoader() {
    this.templateListTarget.innerHTML = Loader
  }

  toggleFilter({ target }) {
    const filterId = target.closest('.filter--chip').id
    const filter = document.querySelector(
      `.form-template--filter-modal [value='${filterId}']`
    )
    filter.checked = false
    this.filteredNavigation()
  }

  filteredNavigation() {
    const searchParams = this.getSearchParams()
    const filterParams = this.getActiveFilters()
    const searchURL = `/mobile-forms-apps/search?${[
      searchParams,
      filterParams,
    ].join('&')}`

    if (this.hasTemplateListTarget) {
      var loading = true
      setTimeout(() => loading && this.setLoader(), 200)

      fetch(searchURL)
        .then((res) => res.text())
        .then((rawResponse) => {
          loading = false
          const parser = new DOMParser()
          const html = parser.parseFromString(rawResponse, 'text/html')
          this.updateResults(html)
        })
        .catch((e) => {
          loading = false
          window.location = searchURL
        })
    } else {
      window.location = searchURL
    }
  }

  getActiveFilters() {
    const activeFilters = [
      ...document.querySelectorAll('.form-template--filter-modal :checked'),
    ]

    const filterParams = activeFilters.length
      ? `filters=${activeFilters.map(({ value }) => value).join(',')}`
      : null
    return filterParams
  }

  getSearchParams() {
    const form = this.searchTarget
    const inputs = [...form.querySelectorAll('input')].filter(
      ({ value }) => value
    )
    const order = this.hasOrderTarget && this.orderTarget.value
    const searchParams = [...inputs, order && { name: 'order', value: order }]
      .map(
        (input) =>
          `${input.name}=${input.value && input.value.replace(' ', '+')}`
      )
      .join('&')
    return searchParams
  }

  doSearch(e) {
    e.preventDefault()
    this.filteredNavigation()
  }

  autoComplete({ target }) {
    const searchValue = target.value
    const el = this.autocompleteOptionsTarget
    const dropdown = el.parentElement.querySelector('.search--input')
    if (searchValue.length >= 3) {
      const query = [searchValue, this.getActiveFilters()]
        .filter((a) => a)
        .join('&')
      fetch(`/mobile-forms-apps/autocomplete.json?term=${query}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.length) {
            this.setAutocompleteListener()
            const search = searchValue.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
            const replacer = new RegExp(
              '(' + search.split(' ').join('|') + ')',
              'gi'
            )
            const autoCompleteList = data
              .map(({ label }) => {
                const searchLabel = label.replace(replacer, '<b>$1</b>')
                return `<div class="dropdown--option" role="option" data-value="${label}" data-action="click->form-templates#setSearchValue">${searchLabel}</div>`
              })
              .join('\n')

            dropdown.classList.add('dropdown-input__open')
            el.innerHTML = autoCompleteList
          } else {
            dropdown.classList.remove('dropdown-input__open')
          }
        })
    } else {
      dropdown.classList.remove('dropdown-input__open')
      el.innerHTML = ''
    }
  }

  setAutocompleteListener() {
    document.addEventListener(
      'click',
      ({ target }) => {
        const optionsList = this.autocompleteOptionsTarget
        const optionsVisible = document.querySelector(
          '.form-template--search .dropdown-input__open'
        )
        if (optionsVisible && !optionsList.contains(target)) {
          optionsVisible.classList.remove('dropdown-input__open')
        }
      },
      { once: true }
    )
  }

  setSearchValue(e) {
    const searchInput = this.searchTarget.querySelector('.search--input #terms')
    const newValue = e.target.getAttribute('data-value')
    searchInput.value = newValue
    this.searchTarget.submit()
  }
}
